import { CardDashboard, DocumentsGallery, Typography } from '@percent/lemonade'
import { useTranslation } from 'react-i18next'
import { CandidateDocumentsProps } from './CandidateDocuments.types'

export const CandidateDocuments = ({ documents }: Readonly<CandidateDocumentsProps>) => {
  const { t } = useTranslation()

  return (
    <CardDashboard title={t('grants.grantDetails.candidateDocuments.title')} data-testid="candidate-documents-card">
      {documents.length > 0 ? (
        <DocumentsGallery
          files={documents}
          withPreview
          documentPreviewLabels={{
            cannotPreview: t('grants.grantDetails.candidateDocuments.cannotPreview'),
            download: t('grants.grantDetails.candidateDocuments.download')
          }}
        />
      ) : (
        <Typography>{t('grants.grantDetails.candidateDocuments.noDocuments')}</Typography>
      )}
    </CardDashboard>
  )
}
